import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  BehaviorSubject,
  Observable,
  ReplaySubject,
  lastValueFrom,
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

export const API_URI = environment.base_uri;

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public userEmitter = new ReplaySubject();
  public userObservable = this.userEmitter.asObservable();

  constructor(private _router: Router, private _http: HttpClient) {}

  public async getUser(): Promise<any> {
    try {
      const user = await lastValueFrom(this.userEmitter);
      return user;
    } catch (error) {
      this.logout();
      return null;
    }
  }

  public async getPaymentLink(param1: string, param2: string): Promise<any> {
    let url: string = `app/payment-links/get?param1=${param1}&param2=${param2}`;

    try {
      const response = await lastValueFrom(this.get(url, true));
      // if (!response.data) this._router.navigate(['/admin/404']);
      return response.data;
    } catch (error) {
      this._router.navigate(['/admin/404']);
      return null;
    }
  }

  public logout(): void {
    this.post('api/sanctum/logout', {}).subscribe({
      next: (response: any) => {
        console.log('ApiService logout response', response);
        localStorage.removeItem('token');
        this._router.navigate(['']).then(() => {
          window.location.href = window.location.href;
        });
      },
      error: (error: any) => {
        console.log('ApiService logout error', error);
        localStorage.removeItem('token');
      },
    });
  }

  /** GET REQUEST */
  public get(url: string, guest: boolean = false): Observable<any> {
    return this._http.get(`${API_URI}/${url}`, this._getOptions(guest));
  }

  getImage(url: string): Observable<any> {
    return this._http.get(`${API_URI}/${url}`, {
      headers: this._getBlobOptions(),
      responseType: 'blob',
    });
  }

  /** POST REQUEST */
  public post(
    url: string,
    params: any,
    guest: boolean = false
  ): Observable<any> {
    return this._http.post(
      `${API_URI}/${url}`,
      params,
      this._getOptions(guest)
    );
  }

  /** PUT REQUEST */
  public put(url: string, params: any): Observable<any> {
    return this._http.put(`${API_URI}/${url}`, params, this._getOptions());
  }

  /** DELETE REQUEST */
  public delete(url: string, id: number): Observable<any> {
    return this._http.delete(`${url}/${id}`, this._getOptions());
  }

  /** HTTP HEADERS */
  private _getOptions(guest: boolean = false) {
    let token: string | null = !!guest
      ? environment.token_api_tools
      : localStorage.getItem('token');

    let httpOptions = {
      headers: new HttpHeaders({
        observe: 'response',
        responseType: 'json',
        Authorization: 'Bearer ' + token,
      }),
    };
    return httpOptions;
  }

  private _getBlobOptions() {
    let token: string | null = localStorage.getItem('token');

    let httpOptions = {
      Authorization: 'Bearer ' + token,
    };
    return httpOptions;
  }
}
